import { Component, OnInit } from '@angular/core';
import { User} from '../../models/user.model';
import { AuthService } from '../../services/auth.service';
import { SearchService } from '../../services/search.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html'
})
export class HeaderComponent implements OnInit {

  user: User;

  constructor(private authService: AuthService, private searchService: SearchService, private router: Router) {}

  ngOnInit() {
    this.authService.currentUser.subscribe(currentUser => {
      this.user = currentUser;
    });
  }

  logout() {
    this.authService.logout();
  }

  get isAdmin() {
    return this.authService.isAdmin;
  }

  get isLoggedIn() {
    return this.authService.isLoggedIn;
  }

  showSearchBar(): boolean {
    return this.searchService.active;
  }

  isActive(route: string): boolean {
    switch (route) {
      case '/list':
        return this.router.url.search('detail') !== -1 || this.router.url.search('list') !== -1;
      default:
        return false;
    }
  }

}
